module.exports = __webpack_public_path__ + "img/note-favorite.0623a09c.svg";